"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
exports.IconButton = react_1.default.memo(function (_a) {
    var id = _a.id, icon = _a.icon, label = _a.label, onClick = _a.onClick, badgeContent = _a.badgeContent, hasBadge = _a.hasBadge, inverted = _a.inverted, role = _a.role, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, _c = _a.color, color = _c === void 0 ? '#000' : _c, _d = _a.disabledColor, disabledColor = _d === void 0 ? 'rgba(0, 0, 0, 0.26)' : _d, hoverColor = _a.hoverColor, bgColor = _a.bgColor, isSelected = _a.isSelected, _e = _a.selectedBgColor, selectedBgColor = _e === void 0 ? '#000' : _e, _f = _a.selectedColor, selectedColor = _f === void 0 ? '#fff' : _f, _g = _a.setPadding, setPadding = _g === void 0 ? true : _g, iconWidth = _a.iconWidth, iconHeight = _a.iconHeight, rest = __rest(_a, ["id", "icon", "label", "onClick", "badgeContent", "hasBadge", "inverted", "role", "fullWidth", "color", "disabledColor", "hoverColor", "bgColor", "isSelected", "selectedBgColor", "selectedColor", "setPadding", "iconWidth", "iconHeight"]);
    var classes = (0, styles_1.default)({
        fullWidth: fullWidth,
        color: color,
        hoverColor: hoverColor,
        bgColor: bgColor,
        isSelected: isSelected,
        selectedColor: selectedColor,
        selectedBgColor: selectedBgColor,
        setPadding: setPadding,
        iconWidth: iconWidth,
        iconHeight: iconHeight,
        disabled: rest.disabled,
    });
    var iconWithProps = react_1.default.cloneElement(icon, {
        // TODO: replace with useTheme and action.disabled palette color
        color: rest.disabled ? disabledColor : color,
        isSelected: isSelected,
        'data-testid': 'icon',
    });
    return ((0, jsx_runtime_1.jsxs)(core_1.ButtonBase, __assign({ id: id, onClick: onClick, className: classes.root, "aria-label": label, role: role }, rest, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.icon }, { children: hasBadge ? (
                // TODO: move this to an atom
                (0, jsx_runtime_1.jsx)(core_1.Badge, __assign({ color: "secondary", badgeContent: badgeContent, "data-testid": "badge" }, { children: iconWithProps }))) : (iconWithProps) })), label && ((0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: id, "data-testid": "label", className: classes.label }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ className: classes.typography, variant: "caption" }, { children: label })) })))] })));
});
